import { get } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { i18nGet } from 'src/tools/tools';

const TopLeft = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const { name } = props;
  const s = useParams();
  const salesChannel = useSalesChannel();
  //console.log('salesChannels,', salesChannel);
  const { name } = salesChannel || {};
  // const uuid = get(s, 'uuid');
  //  const discountUuid = get(s, 'discountUuid');
  const salesChannelUuid = get(s, 'uuid');
  const h = useHistory();
  const goBack = () => {
    h.push(`/salesChannel/promotionTagList/${salesChannelUuid}`);
  };

  const b = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/salesChannels`,
      name: getI18n('general.sider.salesChannel'),
    },
    {
      url: `/salesChannel/content/${salesChannelUuid}`,
      name: name,
    },
    {
      url: `/salesChannel/promotionTagList/${salesChannelUuid}`,
      name: getI18n('general.products'),
    },
    {
      url: `/salesChannel/promotionTagList/${salesChannelUuid}`,
      name: getI18n('salesChannelPromotionTag.index.promotionTags'),
    },
    {
      url: ``,
      name: getI18n('general.edit'),
    },
    // {
    //   url: ``,
    //   name: name,
    // },
  ];
  return <_TopLeft goBack={goBack} breadcrumbData={b} />;
};
export default TopLeft;
